import React from "react";
import { useToast } from "@chakra-ui/react";

export function useCustomToast(node: () => React.ReactNode) {
  const toast = useToast();
  return React.useCallback(
    () =>
      toast({
        position: "bottom-right",
        render: node,
        duration: 5000,
      }),
    [node, toast],
  );
}
